module.exports = __webpack_public_path__ + "b07750d34f9464a0d1bee07433ad72fb.png";